import { registerComponent } from '@gig/magic-common';
import VerifyPromptComponent from './verify-prompt.vue.js';

var VerifyPrompt = registerComponent(VerifyPromptComponent);

export { VerifyPrompt };
